import React from 'react';
import { S } from './style';
export default function Spinner({ size, color }) {
    return <S.Layout style={{ fontSize: size, color }}/>;
}
